import { datadogRum } from '@datadog/browser-rum'

import { User } from 'api/types/userApiTypes'
import { isProdEnvironment, isStagingEnvironment, isZeusEnvironment } from 'utils/environment'

const QA_WOLF_EMAIL = 'taxbit@qawolf.email'
const SYNTHETIC_USER_EMAIL = 'accounting-synthetic@taxbit.com'

export const shouldRecordSessionReplay = (email: string): boolean =>
  email !== QA_WOLF_EMAIL && email !== SYNTHETIC_USER_EMAIL

export const initializeDatadog = () => {
  if (window.location.hostname === 'localhost') {
    return
  }

  try {
    datadogRum.init({
      applicationId: '9a88b422-0791-4798-82a1-a6c88424243a',
      clientToken: 'pub50658601f187680ef775ad6f10ed65b0',
      site: 'datadoghq.com',
      service: 'accounting-suite',
      env: isProdEnvironment()
        ? 'prod'
        : isStagingEnvironment()
          ? 'staging'
          : isZeusEnvironment()
            ? 'zeus'
            : 'dev',
      sessionSampleRate: 100,
      sessionReplaySampleRate: 100,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'mask-user-input',
      version: window.appVersion,
    })
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Unable to initialize Datadog', error)
  }
}

export const updateDatadogUser = ({ id, email, user_name }: User, organizationName: string) => {
  try {
    datadogRum.setUser({
      id,
      name: user_name,
      email,
      organizationName,
    })

    if (!shouldRecordSessionReplay(email)) {
      datadogRum.stopSessionReplayRecording()
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Unable to update Datadog user', error)
  }
}
